/* NANIMERICA collection page (sections/nr-collection): instant filters, sort, size memory, tiles, show more,
   sold-out seeding, "sold out" stat filter and Notify me (Klaviyo Back in Stock).
   Featured order: the first two rows are always buyable, then one sold-out piece after every 5 buyable ones
   (sold-out pieces in collection order). Any other sort puts in-stock pieces first. */
(function () {
  if (window.nrCollection) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SO_EVERY = 5;

  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      if (val === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function headerOffset() {
    var h = 0;
    var els = document.querySelectorAll('.shopify-section-group-header-group, sticky-header, header');
    for (var i = 0; i < els.length; i++) {
      var cs = window.getComputedStyle(els[i]);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      var r = els[i].getBoundingClientRect();
      if (r.height > 0 && r.top <= 1 && r.bottom > 0) h = Math.max(h, Math.round(r.bottom));
    }
    return h;
  }

  function init(root) {
    if (!root || root.nrReady) return;
    root.nrReady = true;
    root.classList.add('is-js');

    var grid = root.querySelector('[data-nrc-grid]');
    var items = Array.prototype.slice.call(grid.querySelectorAll('.nrc-it'));
    var total = items.length;
    var tilesBox = root.querySelector('[data-nrc-tiles]');
    var tiles = tilesBox ? Array.prototype.slice.call(tilesBox.children) : [];
    tiles.forEach(function (t) { tilesBox.removeChild(t); });
    tiles.sort(function (a, b) { return (+a.getAttribute('data-pos')) - (+b.getAttribute('data-pos')); });

    var bar = root.querySelector('[data-nrc-bar]');
    var countEl = root.querySelector('[data-nrc-count]');
    var clears = Array.prototype.slice.call(root.querySelectorAll('[data-nrc-clear]'));
    var empty = root.querySelector('[data-nrc-empty]');
    var more = root.querySelector('[data-nrc-more]');
    var moreBtn = root.querySelector('[data-nrc-more-btn]');
    var seen = root.querySelector('[data-nrc-seen]');
    var fill = root.querySelector('[data-nrc-fill]');
    var sortSel = root.querySelector('[data-nrc-sort]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('.nrc-chip'));
    var saleBtn = root.querySelector('.nrc-tool--sale');
    var soToggle = root.querySelector('[data-nrc-so-toggle]');
    var soStat = soToggle ? soToggle.closest('.nrc-stat') : null;
    var sizeWrap = root.querySelector('[data-nrc-size]');
    var sizeBtn = root.querySelector('[data-nrc-size-btn]');
    var sizeLabel = root.querySelector('[data-nrc-size-label]');
    var pop = sizeWrap ? sizeWrap.querySelector('.nrc-pop') : null;
    var szBtns = Array.prototype.slice.call(root.querySelectorAll('.nrc-sz'));
    var noun = root.getAttribute('data-noun') || 'pieces';
    var per = parseInt(root.getAttribute('data-per'), 10) || 24;
    var sizeKey = 'nrc-size-' + (root.getAttribute('data-size-key') || 'size');
    var sizeDefault = sizeLabel ? sizeLabel.textContent : '';

    var st = { m: [], s: [], sale: false, so: false, z: '', sort: 'featured', limit: per };

    /* Initial state from the URL (shareable), then the remembered size */
    var q = new URLSearchParams(window.location.search);
    if (q.get('sale') === '1') st.sale = true;
    if (q.get('sold') === '1' && soToggle) st.so = true;
    if (q.get('sort')) st.sort = q.get('sort');
    var zq = q.get('size') || (szBtns.length && !st.so ? store(sizeKey) : '');
    if (zq && szBtns.some(function (b) { return b.getAttribute('data-z') === zq; })) st.z = zq;
    if (sortSel) {
      if (!sortSel.querySelector('option[value="' + st.sort + '"]')) st.sort = 'featured';
      sortSel.value = st.sort;
    }

    function has(list, val) { return list.indexOf(val) > -1; }
    function filtered() { return st.m.length || st.s.length || st.sale || st.so || st.z; }
    function isSo(el) { return el.classList.contains('is-so'); }
    function cols() { return window.getComputedStyle(grid).gridTemplateColumns.split(' ').length || 1; }

    function match(el) {
      var d = el.dataset;
      if (st.so && !isSo(el)) return false;
      if (st.sale && d.sale !== '1') return false;
      if (st.z && d.z.indexOf('|' + st.z + '|') < 0) return false;
      return true;
    }

    function score(el) {
      var r = parseFloat(el.dataset.r) || 0, n = parseInt(el.dataset.n, 10) || 0;
      return r * Math.log(n + 2);
    }
    function byIndex(a, b) { return +a.dataset.i - +b.dataset.i; }
    function sorter(a, b) {
      var A = a.dataset, B = b.dataset;
      var sa = isSo(a), sb = isSo(b);
      if (sa !== sb) return sa ? 1 : -1;
      switch (st.sort) {
        case 'price-asc': return (+A.p - +B.p) || (+A.i - +B.i);
        case 'price-desc': return (+B.p - +A.p) || (+A.i - +B.i);
        case 'rating': return (score(b) - score(a)) || (+A.i - +B.i);
        case 'reviews': return ((+B.n) - (+A.n)) || (+A.i - +B.i);
        case 'new': return ((+B.d) - (+A.d)) || (+A.i - +B.i);
        default: return +A.i - +B.i;
      }
    }

    /* Featured: two full rows of buyable pieces (plus two more), then a sold-out piece after every SO_EVERY buyable ones */
    function arrange(list) {
      if (st.sort !== 'featured' || st.so) return list.sort(sorter);
      var av = list.filter(function (el) { return !isSo(el); }).sort(byIndex);
      var so = list.filter(isSo).sort(byIndex);
      if (!av.length || !so.length) return av.concat(so);
      var lead = cols() * 2;
      var out = [], j = 0;
      av.forEach(function (el, k) {
        out.push(el);
        var n = k + 1;
        if (n >= lead + 2 && (n - lead - 2) % SO_EVERY === 0 && j < so.length) out.push(so[j++]);
      });
      return out.concat(so.slice(j));
    }

    function short(z) { return z.split(' (')[0]; }
    /* Shown size in the visitor's scale (from the chip's data-label); matching always uses the US value */
    function zlabel(z) {
      for (var i = 0; i < szBtns.length; i++) if (szBtns[i].getAttribute('data-z') === z) return szBtns[i].getAttribute('data-label') || short(z);
      return short(z);
    }

    function fitLabels() {
      items.forEach(function (el) {
        var meta = el.querySelector('.nrh-card__meta > span:first-child');
        if (!meta) return;
        if (meta.nrOrig === undefined) meta.nrOrig = meta.innerHTML;
        if (st.z && el.dataset.z.indexOf('|' + st.z + '|') > -1) {
          meta.innerHTML = '<span class="nrc-fit">' + (/^\d/.test(st.z) ? 'Size ' : '') + zlabel(st.z).replace(/</g, '') + ' in stock</span>';
        } else {
          meta.innerHTML = meta.nrOrig;
        }
      });
    }

    function syncUrl() {
      var u = new URL(window.location.href);
      ['material', 'series', 'sale', 'sold', 'sort', 'size'].forEach(function (k) { u.searchParams.delete(k); });
      if (st.sale) u.searchParams.set('sale', '1');
      if (st.so) u.searchParams.set('sold', '1');
      if (st.sort !== 'featured') u.searchParams.set('sort', st.sort);
      if (st.z) u.searchParams.set('size', st.z);
      try { window.history.replaceState(window.history.state, '', u.toString()); } catch (e) {}
    }

    function paintControls() {
      chips.forEach(function (c) {
        var f = c.getAttribute('data-f'), v = c.getAttribute('data-v'), on;
        if (f === 'all') on = !st.m.length && !st.s.length;
        else on = has(f === 'm' ? st.m : st.s, v);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (saleBtn) saleBtn.setAttribute('aria-pressed', st.sale ? 'true' : 'false');
      if (soToggle) {
        soToggle.setAttribute('aria-pressed', st.so ? 'true' : 'false');
        if (soStat) soStat.classList.toggle('is-on', st.so);
      }
      if (sizeWrap) {
        sizeWrap.classList.toggle('is-on', !!st.z);
        if (sizeLabel) sizeLabel.textContent = st.z ? (/^\d/.test(st.z) ? 'Size ' : '') + zlabel(st.z) : sizeDefault;
        szBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-z') === st.z ? 'true' : 'false'); });
      }
      clears.forEach(function (c) { if (c.closest('[data-nrc-status]')) c.hidden = !filtered(); });
    }

    function render(animate) {
      var list = arrange(items.filter(match));
      var rest = items.filter(function (el) { return list.indexOf(el) < 0; });
      var n = list.length;
      var shown = Math.min(n, st.limit);
      var useTiles = !filtered() && st.sort === 'featured';
      /* End on a full row when there is more to show */
      if (shown < n) {
        var c = cols();
        var tc = useTiles ? tiles.filter(function (t) { return (+t.getAttribute('data-pos')) <= shown; }).length : 0;
        var rem = (shown + tc) % c;
        if (rem && shown - rem > 0) shown -= rem;
      }
      var frag = document.createDocumentFragment();
      var ti = 0;
      list.forEach(function (el, i) {
        while (useTiles && ti < tiles.length && (+tiles[ti].getAttribute('data-pos')) === i + 1 && i < shown) {
          tiles[ti].hidden = false;
          frag.appendChild(tiles[ti]);
          ti++;
        }
        var wasHidden = el.hidden;
        el.hidden = i >= shown;
        el.classList.toggle('is-new', !!animate && !el.hidden && (wasHidden || animate === 'all') && !reduce.matches);
        frag.appendChild(el);
      });
      tiles.forEach(function (t, k) { if (k >= ti) { t.hidden = true; frag.appendChild(t); } });
      rest.forEach(function (el) { el.hidden = true; el.classList.remove('is-new'); frag.appendChild(el); });
      grid.appendChild(frag);
      root.nrOrder = list;

      var word = n === 1 ? noun.replace(/s$/, '') : noun;
      if (st.so && !st.sale && !st.z) countEl.textContent = n + ' sold out · ' + (total - n) + ' still available';
      else countEl.textContent = filtered() ? n + ' of ' + total + ' ' + noun : n + ' ' + word;
      if (empty) empty.hidden = n > 0;
      if (more) {
        more.hidden = n <= shown;
        if (seen) seen.textContent = 'Showing ' + shown + ' of ' + n;
        if (fill) fill.style.width = (n ? Math.round(shown / n * 100) : 0) + '%';
      }
      fitLabels();
      paintControls();
      syncUrl();
    }

    function toGrid(always) {
      if (!always && !(bar && bar.classList.contains('is-stuck'))) return;
      var y = grid.getBoundingClientRect().top + window.pageYOffset - (bar ? bar.offsetHeight : 0) - headerOffset() - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    function changed(always) {
      st.limit = per;
      render('all');
      toGrid(always);
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.getAttribute('data-f'), v = c.getAttribute('data-v');
        if (f === 'all') { st.m = []; st.s = []; }
        else {
          var list = f === 'm' ? st.m : st.s;
          var i = list.indexOf(v);
          if (i > -1) list.splice(i, 1); else list.push(v);
        }
        changed();
      });
    });
    if (saleBtn) saleBtn.addEventListener('click', function () { st.sale = !st.sale; changed(); });
    if (soToggle) soToggle.addEventListener('click', function () {
      st.so = !st.so;
      /* sold-out pieces have no size in stock, so a size filter would empty the grid */
      if (st.so) st.z = '';
      changed(true);
    });
    if (sortSel) sortSel.addEventListener('change', function () { st.sort = sortSel.value; changed(); });
    clears.forEach(function (c) {
      c.addEventListener('click', function () {
        st.m = []; st.s = []; st.sale = false; st.so = false;
        if (st.z) { st.z = ''; store(sizeKey, null); }
        changed();
      });
    });
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var first = (root.nrOrder || [])[st.limit];
      st.limit += per;
      render(true);
      if (first) {
        var a = first.querySelector('a');
        if (a) a.focus({ preventScroll: true });
      }
    });

    /* Size popover */
    function openPop(on) {
      if (!pop) return;
      pop.hidden = !on;
      sizeBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) {
        var sel = pop.querySelector('[aria-pressed="true"]') || pop.querySelector('.nrc-sz');
        if (sel) sel.focus({ preventScroll: true });
        var r = pop.getBoundingClientRect();
        if (r.right > window.innerWidth - 12) pop.style.left = (window.innerWidth - 12 - r.width - sizeWrap.getBoundingClientRect().left) + 'px';
      } else {
        pop.style.left = '';
      }
    }
    if (sizeBtn) {
      sizeBtn.addEventListener('click', function (e) { e.stopPropagation(); openPop(pop.hidden); });
      szBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var z = b.getAttribute('data-z');
          st.z = st.z === z ? '' : z;
          if (st.z) st.so = false;
          store(sizeKey, st.z || null);
          openPop(false);
          sizeBtn.focus({ preventScroll: true });
          changed();
        });
      });
      var szClear = root.querySelector('[data-nrc-size-clear]');
      if (szClear) szClear.addEventListener('click', function () {
        st.z = ''; store(sizeKey, null); openPop(false); changed();
      });
      document.addEventListener('click', function (e) { if (pop && !pop.hidden && !sizeWrap.contains(e.target)) openPop(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop && !pop.hidden) { openPop(false); sizeBtn.focus(); } });
    }

    /* Notify me: Klaviyo Back in Stock for the chosen variant */
    var nd = root.querySelector('[data-nrc-nd]');
    if (nd) {
      var site = root.getAttribute('data-klaviyo') || '';
      var ndName = nd.querySelector('[data-nrc-nd-name]');
      var ndFields = nd.querySelector('[data-nrc-nd-fields]');
      var ndSizeWrap = nd.querySelector('[data-nrc-nd-size-wrap]');
      var ndSizeLbl = ndSizeWrap.querySelector('span');
      var ndSize = nd.querySelector('[data-nrc-nd-size]');
      var ndEmail = nd.querySelector('[data-nrc-nd-email]');
      var ndGo = nd.querySelector('[data-nrc-nd-go]');
      var ndErr = nd.querySelector('[data-nrc-nd-err]');
      var ndOk = nd.querySelector('[data-nrc-nd-ok]');
      var ndForm = nd.querySelector('form');
      var ndBtn = null, ndVariants = [];
      var saved = store('nrc-email') || '';

      function closeNd() {
        if (nd.close && nd.open) nd.close(); else nd.removeAttribute('open');
      }
      function openNd(btn) {
        ndBtn = btn;
        try { ndVariants = JSON.parse(btn.getAttribute('data-variants') || '[]'); } catch (e) { ndVariants = []; }
        ndName.textContent = btn.getAttribute('data-title') || '';
        ndSize.innerHTML = '';
        ndVariants.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id; o.textContent = v.t;
          ndSize.appendChild(o);
        });
        var pick = ndVariants.length > 1;
        ndSizeWrap.hidden = !pick;
        var multi = ndVariants.some(function (v) { return v.t.indexOf(' / ') > -1; });
        ndSizeLbl.textContent = btn.hasAttribute('data-sized') ? (multi ? 'Finish and size' : 'Size') : 'Option';
        if (pick && btn.hasAttribute('data-sized') && st.z) {
          ndVariants.some(function (v) {
            if (v.t.split(' / ').some(function (x) { var m = x.match(/\(US ([^)]+)\)$/); return (m ? m[1] : x) === st.z; })) { ndSize.value = v.id; return true; }
          });
        }
        ndFields.hidden = false;
        ndOk.hidden = true;
        ndErr.hidden = true;
        ndGo.disabled = false;
        if (!ndEmail.value && saved) ndEmail.value = saved;
        if (nd.showModal) nd.showModal(); else nd.setAttribute('open', '');
        (pick ? ndSize : ndEmail).focus();
      }

      grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-nrc-notify]');
        if (!b) return;
        e.preventDefault();
        openNd(b);
      });
      nd.querySelector('[data-nrc-nd-close]').addEventListener('click', closeNd);
      nd.addEventListener('click', function (e) { if (e.target === nd) closeNd(); });
      nd.addEventListener('close', function () { if (ndBtn) ndBtn.focus({ preventScroll: true }); });

      ndForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (ndEmail.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          ndErr.textContent = 'Please enter a valid email.';
          ndErr.hidden = false;
          ndEmail.focus();
          return;
        }
        var vid = ndSize.value || (ndVariants[0] && ndVariants[0].id);
        if (!vid || !site) { ndErr.textContent = 'Something went wrong. Please try again.'; ndErr.hidden = false; return; }
        ndErr.hidden = true;
        ndGo.disabled = true;
        var body = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } }
          }
        };
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(site), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          store('nrc-email', email);
          saved = email;
          ndFields.hidden = true;
          ndOk.hidden = false;
          if (ndBtn) {
            ndBtn.classList.add('is-done');
            var s = ndBtn.querySelector('span');
            if (s) s.textContent = 'On the list';
          }
        }).catch(function () {
          ndGo.disabled = false;
          ndErr.textContent = 'We couldn’t save that just now. Please try again.';
          ndErr.hidden = false;
        });
      });
    }

    /* Sticky bar sits under a sticky header */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var top = headerOffset();
        root.style.setProperty('--nrc-top', top + 'px');
        if (bar) bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= top + 1 && window.pageYOffset > 0);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    var lastCols = cols();
    window.addEventListener('resize', function () {
      var c = cols();
      if (c !== lastCols) { lastCols = c; render(false); }
    });
    onScroll();

    render(false);
  }

  window.nrCollection = { init: init };
  function all() { document.querySelectorAll('[data-nrc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-nrc]'); if (r) init(r); });
})();
